import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import quiz from './modules/quiz'
import question from './modules/question'
import tag from './modules/tag'
import page from './modules/page'
import blog from './modules/blog'
import log from './modules/log'
import resultMessage from './modules/resultMessage'
import coupon from './modules/coupon'
import school from './modules/school'
import schoolDistrict from './modules/schoolDistrict'
import requestToPlus from './modules/requestToPlus'
import teacherRequest from './modules/teacherRequest'
import payout from './modules/payout'
import settings from './modules/settings'

import axios from 'axios'
import API_URL from '@/router/api'

Vue.use(Vuex)

const isDarkMode = localStorage.getItem('darkmode') === "true" ? true : false;

var initState = {
    isDarkMode: isDarkMode,
    imageSearchList: null,
    imageServerSelect: null
}

export default new Vuex.Store({
    state: initState,

    mutations: {
        changeMode() {
            this.state.isDarkMode = !this.state.isDarkMode
        },

        updateImageSearch: function (state, data) {
            state.imageSearchList = data
        },

        updateServerImageSelect: function(state, data){
            state.imageServerSelect = data
        },
    },

    actions: {
        fetchImageSearch(context, key) {

            return new Promise((resolve, reject) => {

                let param = {
                    q: key || ""
                }

                axios({
                    method: 'post',
                    baseURL: process.env.VUE_APP_API_BASE_URL.replace('/admin', ''),
                    url: API_URL.fetchImageSearch,
                    data: param
                })
                    .then((res) => {
                        if (res.status === 200) {
                            context.commit('updateImageSearch', res.data.data)
                            resolve()
                        } else {
                            reject()
                        }

                    })
                    .catch(() => {
                        reject()
                    })
            })
        },

        fetchServerImage(context, data){

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    baseURL: process.env.VUE_APP_API_BASE_URL.replace('/admin', ''),
                    url: API_URL.generateImageSearch,
                    data: data,
                    timeout: 5000
                })
                .then((res) => {
                    if(res.status === 200){
                        let myFile = {
                            img_url: res.data.data.img_url,
                            source: res.data.data.source,
                            external: true
                        }
                        context.commit('updateServerImageSelect', myFile)
                        resolve(myFile)
                    }else{
                        let myFile = {
                            img_url: data.thumbnail,
                            source: data.source,
                            external: true
                        }

                        context.commit('updateServerImageSelect', myFile)
                        resolve(myFile)
                    }

                })
                .catch((e) => {
                    reject(e)
                })
            })
        },
    },

    getters: {
        getImageSearch: function (state) {
            return state.imageSearchList
        },

        getImageServerSelect: function(state){
            return state.imageServerSelect
        },

        isDarkMode(state) {
            return state.isDarkMode
        }
    },

    modules: {
        user,
        quiz,
        question,
        tag,
        page,
        blog,
        log,
        resultMessage,
        coupon,
        school,
        schoolDistrict,
        requestToPlus,
        teacherRequest,
        payout,
        settings
    }
})
